import { z } from 'zod';
import { internalReportTypes, ReportType, reportGroups } from '../report-catalog';

const availableReportTypes = reportGroups.reduce<ReportType[]>((reportTypes, group) => {
	for (const report of group.reports) {
		if (report.isAvailable) {
			reportTypes.push(report.key);
		}
	}

	return reportTypes;
}, []);

const jobReportTypes = [...availableReportTypes, ...internalReportTypes] as unknown as [ReportType, ...ReportType[]];

export const reportTypeSchema = z.enum(jobReportTypes);
